import { iconClose } from '@cube3/ui/src/icons/GeneralSVG';
import {
  archivedProjectTooltip,
  readOnlyProjectTooltip
} from '../../../../CommandBar/factories/tooltip';
import {
  ButtonFactory,
  ButtonFactoryConfig
} from '../../../../CommandBar/useButtonConfig';

export const detachContractButtonFactory = (
  onClick: () => void,
  contract
): ButtonFactory => {
  const f = (config: ButtonFactoryConfig) => {
    const { canWriteContract } = config.privileges;
    const { isProjectArchived, isProjectRoleReadOnly } = config;

    const disabledReason = (() => {
      switch (true) {
        case !canWriteContract:
          return 'This account has no permission to detach contract';
        case isProjectRoleReadOnly:
          return readOnlyProjectTooltip;
        case isProjectArchived:
          return archivedProjectTooltip;
        default:
          return undefined;
      }
    })();

    return {
      title: 'Detach Contract',
      visible: true,
      disabled:
        !contract ||
        !canWriteContract ||
        isProjectRoleReadOnly ||
        isProjectArchived,
      disabledReason,
      icon: iconClose,
      onClick: onClick
    };
  };

  return {
    factory: f
  };
};
